import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';

import { AuthService } from './services/auth.service';
import { FileService } from './services/file.service';
import { NotificationService } from './services/notification.service';
import { ToastComponent } from './shared/toast/toast.component';
import { ee } from './shared/constants';

declare let $: any;
declare let bootstrap: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewChecked {
  auth = inject(AuthService);
  toast = inject(ToastComponent);
  private fileService = inject(FileService);
  private notificationService = inject(NotificationService);
  private changeDetector = inject(ChangeDetectorRef);


  unreadCount = 0;
  version = localStorage.getItem('version');

  ngOnInit(): void {
    if (this.auth.loggedIn) {
      this.checkVersion();
      this.getNotifications();
    }
  }

  ngAfterViewChecked(): void {
    // This fixes: https://github.com/DavideViolante/Angular-Full-Stack/issues/105
    this.changeDetector.detectChanges();
    // Enable Bootstrap 5 tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el));
    this.closeMenuOnClickOutside();
  }

  // https://stackoverflow.com/questions/46736823/how-can-i-close-my-bootstrap-4-navbar-collapse-menu-when-clicking-outside-the-me
  closeMenuOnClickOutside(): void {
    $(document).click(event => {
      const clickover = $(event.target);
      const _opened = $('.navbar-collapse').hasClass('show');
      if (_opened && !clickover.hasClass('navbar-toggler')) {
        $('.navbar-toggler').click();
      }
    });
  }

  changeContent(content: string): void {
    ee.emit('changeContent', content);
    if (this.auth.loggedIn) {
      this.checkVersion();
      this.getNotifications();
    }
  }

  checkVersion(): void {
    this.fileService.getVersion()
      .subscribe({
        next: res => {
          if (res !== this.version) {
            this.toast.setMessage(
              'There is a new app version, please <a href="" onClick="location.reload()">click here to refresh</a>.',
              'warning',
              10000);
            localStorage.setItem('version', res);
          }
        },
        error: err => err.error.message === 'Invalid or expired token' ? location.reload() : this.toast.setMessage(err.error.message, 'danger')
      });
  }

  getNotifications(): void {
    const params = {
      _user: this.auth.currentUser._id,
      read: false
    };
    this.notificationService.search(params)
      .subscribe({
        next: res => this.unreadCount = res.count,
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
